<template>
    <div class="release_index" v-loading="loading">
        <div class="release_banner">
            <img src="@/assets/img/index/comments_case/release_bannse.png" alt="">
        </div>
        <div class="sever_check">
            <div class="sever_check_box">
                <div class="sever_title">选择服务</div>
                <div class="sever_borders"></div>
                <div class="check_list">
                    <div class="list_item" v-for="(item, index) in check_list">
                        <div class="item_title">{{ item.title }}</div>
                        <div class="item_text">
                            {{ item.text }}
                        </div>
                        <div class="item_prices">
                            <div class="prices_nums">{{ item.prices }}</div>
                            <div class="prices_text">元/次</div>
                        </div>
                        <div class="item_check">
                            <div class="checks" @click="check_ac = index">
                                <img src="@/assets/img/index/legal/checks_ac.png" alt=""
                                    v-if="check_ac == index">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="check_end_btns">
                    <div class="btns" @click="handle_add">案例发布</div>
                </div>
            </div>
        </div>
        <div class="sever_text_img">
            <div class="sever_text_img_box">

                <div class="sever_title">服务简介</div>
                <div class="sever_borders"></div>
                <div class="sever_img_texts">
                    <div class="sever_imgs">
                        <img src="@/assets/img/index/legal/bg1.png" alt="">
                    </div>
                    <div class="sever_texts">
                        领取独生子女费用，首先你要等到退休之后，办好退休手续，才能到所在地社区或者是村委进行申请填表就可以了。”独生子女“的证件给弄丢了，到所在地的卫计委查“独生子女”申请表底册，复印后就可以证明了，有单位的在单位查底册复印。第一、国家公务员以及事业单位退休的人员，会在退休时将这个独生子女的奖扶政策落入到其本人的退休金当中，退休金中会增调资5%，是随着工资发放的，终身享受的。第二、对于国有企业以及一些大型的龙头企业，在退休的时候有一次性的”独生子女“的优抚金一次性补贴。如果没有发放的，可以参照下面
                    </div>
                </div>
            </div>
        </div>
        <div class="process">
            <div class="process_box">
                <div class="sever_title">服务流程</div>
                <div class="sever_borders"></div>
                <div class="process_list">
                    <div class="process_x" v-for="(item,index) in process_list" :key="index">
                        <div class="process_y" v-for="(items,indexs) in item.list" :key="indexs">
                            <div class="process_y_title">
                                {{ items.title }}
                            </div>
                            <div class="process_y_img" v-if="indexs==0&&index<(process_list.length-1)">
                                <img src="@/assets/img/index/comments_case/rights.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'



export default {
    components: {

    },
    name: "homes",
    data() {
        return {
            loading: false,
            check_ac: 0,
            check_list: [
                {
                    title: '初级点评',
                    text: '',
                    prices: '600',
                },
                {
                    title: '中级点评',
                    text: '',
                    prices: '5000',
                },
                {
                    title: '高级点评',
                    text: '',
                    prices: '8000',
                },
                {
                    title: '特级点评',
                    text: '',
                    prices: '面议',
                },
            ],
            process_list:[
                {
                    list:[
                        {
                            title:'阅读服务简介',//
                        },

                    ]
                },
                {
                    list:[
                        {
                            title:'选择服务',//
                        },

                    ]
                },
                {
                    list:[
                        {
                            title:'初级点评',//
                        },
                        {
                            title:'中级点评',//
                        },
                        {
                            title:'高级点评',//
                        },
                        {
                            title:'特级点评',//
                        },
                    ]
                },
                {
                    list:[
                        {
                            title:'提交资料',//
                        },

                    ]
                },
                {
                    list:[
                        {
                            title:'管理员审核',//
                        },

                    ]
                },
                {
                    list:[
                        {
                            title:'成交下单',//
                        },

                    ]
                },
                {
                    list:[
                        {
                            title:'提供服务',//
                        },

                    ]
                },

            ]

        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        this.get_setting()
    },
    methods: {
        get_setting(){
            this.loading=true
            this.$api("setting", {
				 
			}, "get").then((res) => {
                this.loading = false
                console.log('配置',res)
                if (res.code == 1) {
                    this.check_list= [
                        {
                            title: '初级点评',
                            text: res.data.levelTxt1,
                            prices: res.data.level1,
                            prices_end: res.data.level1,
                        },
                        {
                            title: '中级点评',
                            text: res.data.levelTxt2,  
                            prices: res.data.level2,
                            prices_end: res.data.level2,

                        },
                        {
                            title: '高级点评',
                            text: res.data.levelTxt3,  
                            prices: res.data.level3,
                            prices_end: res.data.level3,

                        },
                        {
                            title: '特级点评',
                            text: res.data.levelTxt4,  
                            prices: '面议',
                            prices_end: res.data.level4,
                        },
                    ]
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_home() {
            this.$router.push({
                path: '/home',
            })
        },
        handle_add(){
            this.$router.push({
                path: '/release_add',
                query:{
                    type:this.check_ac+1,
                    price:this.check_list[this.check_ac].prices_end
                }
            }) 
        },
    },

}
</script>
<style scoped lang="less">
.release_index {
    .release_banner {
        width: 100%;
        height: 480px;

        img {
            width: 100%;
            height: 480px;
        }
    }

    .sever_check {
        // height: 830px;
        background: #F9FBFF;
        padding-bottom: 80px;

        .sever_check_box {
            width: 1440px;
            margin: auto;
            // height: 830px;
            padding-top: 80px;

            .sever_title {
                text-align: center;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: bold;
                font-size: 36px;
                color: #333333;
            }

            .sever_borders {
                width: 80px;
                height: 5px;
                background: #377CFD;
                border-radius: 3px 3px 3px 3px;
                margin: auto;
                margin-top: 24px;
            }

            .check_list {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-top: 80px;

                .list_item {
                    width: 315px;
                    height: 356px;
                    // background: linear-gradient( 180deg, #FFFFFF 0%, rgba(255,255,255,0) 100%);
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    box-shadow: 1px 1px 30px #cdd3d1;
                    padding: 28px;

                    .item_title {
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 20px;
                        color: #333333;
                        text-align: center;
                        padding-top: 30px;
                    }

                    .item_text {
                        padding-top: 24px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        text-align: center;
                        line-height: 36px;
                        height: 150px;
                    }

                    .item_prices {
                        display: flex;
                        align-items: end;
                        justify-content: center;

                        .prices_nums {
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 40px;
                            color: #377CFD;
                        }

                        .prices_text {
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #377CFD;
                        }
                    }

                    .item_check {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding-top: 20px;

                        .checks {
                            width: 32px;
                            height: 32px;
                            background: #FFFFFF;
                            border: 1px solid #D7D7D7;
                            border-radius: 50%;
                            cursor: pointer;

                            img {
                                width: 32px;
                                // height: 32px;
                            }
                        }
                    }

                }
            }

            .check_end_btns {
                display: flex;
                align-items: center;
                justify-content: center;
                padding-top: 80px;
                margin-bottom: 80px;

                .btns {
                    width: 220px;
                    height: 50px;
                    background: #377CFD;
                    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
                    border-radius: 4px 4px 4px 4px;
                    text-align: center;
                    line-height: 50px;
                    cursor: pointer;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 20px;
                    color: #FFFFFF;

                }
            }


        }


    }

    .sever_text_img {
        padding-bottom: 80px;

        .sever_title {
            text-align: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 36px;
            color: #333333;
        }

        .sever_borders {
            width: 80px;
            height: 5px;
            background: #377CFD;
            border-radius: 3px 3px 3px 3px;
            margin: auto;
            margin-top: 24px;
        }

        .sever_text_img_box {
            width: 1440px;
            margin: auto;
            // height: 830px;
            padding-top: 80px;

            .sever_img_texts {
                display: flex;
                align-items: top;
                padding-top: 64px;

                .sever_imgs {
                    flex-shrink: 0;
                    width: 560px;
                    height: 333px;

                    img {
                        width: 560px;
                        height: 333px;
                    }
                }

                .sever_texts {
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 18px;
                    color: #666666;
                    padding-left: 40px;
                }
            }
        }

    }
    .process{
        width: 100%;
        height: 750px;
        background-image: url('../../../assets/img/index/comments_case/bg1.png');
        background-size: 100%;

        .process_box{
            width: 1440px;
            margin: auto;
            padding-top: 80px;
            .sever_title {
                text-align: center;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: bold;
                font-size: 36px;
                color: #333333;
            }

            .sever_borders {
                width: 80px;
                height: 5px;
                background: #377CFD;
                border-radius: 3px 3px 3px 3px;
                margin: auto;
                margin-top: 24px;
            }
            .process_list{
                display: flex;
                align-items: top;
                .process_x{
                    padding-top: 80px;
                    .process_y{
                        display: flex;
                        align-items: center;
                        margin-right: 24px;
                        margin-bottom: 21px;
                        .process_y_title{
                            flex-shrink: 0;
                            width: 158px;
                            height: 92px;
                            background: #FFFFFF;
                            box-shadow: 0px 3px 20px 1px rgba(0,0,0,0.06);
                            border-radius: 20px 20px 20px 20px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 16px;
                            color: #666666;
                        }
                        .process_y_img{
                            margin-left: 24px;
                            flex-shrink: 0;
                            width: 9px;
                            height: 10px;

                            img{
                                vertical-align: middle; 
                                width: 9px;
                                height: 10px;
                            }
                        }
                        

                    }
                }
            }
        }
    }
}
</style>